import loadable from '@loadable/component';

/* istanbul ignore next */
export const SuburbanBlackFridayBannerContainerLoadable = loadable(() => import('./container'), {
  resolveComponent: ({ SuburbanBlackFridayBannerContainer }) => SuburbanBlackFridayBannerContainer,
});
